import { globalStyles } from '@client/shared/constants';

const style = {
  dialog: ({
    minWidth = 720,
    minHeight = 460
  }) => ({
    '& .MuiDialog-paper': {
      minWidth,
      minHeight,
    }
  }),
  closeIcon: {
    fontSize: 28,
    color: 'grey.500'
  },
  dialogAction: {
    borderTop: '1px solid',
    borderColor: 'grey.100'
  },
  divider: {
    position: 'absolute'
  },
  releaseBtn: {
    background: "#F07939",
    '&:hover': {
      background: "#F07939",
    }
  }
};

export default style;